import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import CoreRouter from './CoreRouter';
import AdminRouter from './AdminRouter';
import CoreLayout from './CoreLayout';
import AdminLayout from './AdminLayout';
import AuthContext from '../users/components/AuthProvider';

const AppRouter = () => {
  const { userLogout, isAuthenticated } = useContext(AuthContext);

  return (
    <Routes>
      <Route 
        path="/*" 
        element={
          <CoreLayout userLogout={userLogout}>
            <CoreRouter />
          </CoreLayout>
        } 
      />
      <Route 
        path="/admin/*" 
        element={
          <AdminLayout userLogout={userLogout} isAuthenticated={isAuthenticated}>
            <AdminRouter />
          </AdminLayout>
        } 
      />
    </Routes>
  );
};

export default AppRouter;